import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';

import scss from './NoData.module.scss';

function NoData() {
  const { t } = useTranslation();

  return (
    <div className={scss.wrapper}>
      <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className={scss.icon} />
    </div>
  );
}

export default NoData;
